module.exports = "<div class=\"bc-example\">\n  example\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/bc-example/template.html
// module id = 397
// module chunks = 1